const SupportedByBlock = ()=>{
    const isBlockEnabled = import.meta.env.VITE_SUPPORTED_BY_ENABLED === 'true';
    if (!isBlockEnabled) return null;
    return (
      <>
        <div className="supported-by-block">
          <span>Supported by:</span>
          <img src="/images/crefo.svg" alt="Crefo Frankfurt logo" />
        </div>
      </>
    );
};

export default SupportedByBlock;